// Stati.js
import './Stati.css';
import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
function Stati({ latestDistrict, latestPalika, isEnglish }) {
  const [apiData, setApiData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let apiUrl = 'https://backend.mappersnepal.com.np/total_schools/';
        if (latestDistrict && !latestPalika) {
          apiUrl = `https://backend.mappersnepal.com.np/total_schools/${latestDistrict}/`;
        } else if (latestDistrict && latestPalika) {
          apiUrl = `https://backend.mappersnepal.com.np/total_schools_palika/${latestPalika}/`;
        }

        const response = await fetch(apiUrl);
        const data = await response.json();
        console.log(data);

     

        setApiData(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [latestDistrict, latestPalika]);

  const clearCharts = () => {
    d3.selectAll('.chart-container svg').remove();
    d3.selectAll('.bar-chart-container svg').remove();
  };




   

  const studentChartRef = useRef(null);
  const staffChartRef = useRef(null);
  const eduTypeChartRef = useRef(null);
  const schoolChartRef = useRef(null);

  useEffect(() => {
    if (!apiData) return;

    clearCharts();

    const studentData = [
      { label: isEnglish ? 'Male Student' : 'पुरुष', value: apiData.total_male_students },
      { label: isEnglish ? 'Female Student' : 'महिला', value: apiData.total_female_students },
    ];

    const staffData = [
      { label: isEnglish ? 'Male Staff' : 'पुरुष कर्मचारी', value: apiData.total_male_staff },
      { label: isEnglish ? 'Female Staff' : 'महिला कर्मचारी', value: apiData.total_female_staff },
    ];

    const eduType = [
      { label: isEnglish ? 'Government' : 'सरकारी', value: apiData.total_government_schools },
      { label: isEnglish ? 'Private' : 'निजी', value: apiData.total_private_schools },
    ];

    const schoolData =
    apiData.total_schools_per_palika
      ? apiData.total_schools_per_palika.map((item) => ({
          label: isEnglish ? 'Palikas' : 'पालिकाहरू',
          value: item.PALIKA,
          schools: item.total_palika_schools,
        }))
      : apiData.total_schools_per_district
      ? apiData.total_schools_per_district.map((item) => ({
          label: isEnglish ? 'Districts' : 'जिल्लाहरू',
          value: item.DISTRICT,
          schools: item.total_schools,
        }))
      : apiData.total_schools_per_ward
      ? apiData.total_schools_per_ward.map((item) => ({
          label: isEnglish ? 'Wards' : 'वार्डहरू',
          value: item.WARD_NO,
          schools: item.total_ward_schools,
        }))
      : [];
  
  
  

    createPieChart(studentData, studentChartRef.current);
    createPieChart(staffData, staffChartRef.current);
    createPieChart(eduType, eduTypeChartRef.current);
    createBarChart(schoolData, schoolChartRef.current);
  }, [apiData, isEnglish]);

  const createPieChart = (data, containerRef) => {
    if (!data || data.length === 0) {
      console.log("Data cannot be found."); // Display the message
      return;
    }
    const width = 100;
    const height = 100;
    const radius = Math.min(width, height) / 2;

    const svg = d3.select(containerRef)
        .append('svg')
        .attr('width', width)
        .attr('height', height)
        .append('g')
        .attr('transform', `translate(${width / 2},${height / 2})`);

    const colors = ['#1f77b4', '#ff7f0e'];

    const pie = d3.pie().value(d => d.value);
    const arc = d3.arc().innerRadius(0).outerRadius(radius);

    const arcs = svg.selectAll('arc')
        .data(pie(data))
        .enter()
        .append('g')
        .attr('class', 'arc');

    arcs.append('path')
        .attr('d', arc)
        .attr('fill', (d, i) => colors[i])
        .attr('stroke', '#fff')
        .attr('stroke-width', 2)
        .each(function (d) {
            d3.select(this)
                .transition()
                .duration(1000)
                .attrTween('d', function (d) {
                    const interpolate = d3.interpolateObject({ startAngle: 0, endAngle: 0 }, d);
                    return t => arc(interpolate(t));
                });
        });

    arcs.append('text')
        .attr('transform', d => `translate(${arc.centroid(d)})`)
        .attr('dy', '0.35em')
        .attr('text-anchor', 'middle')
        .attr('fill', '#fff')
        .attr('font-size', '12px')
        .text(d => d.data.value);
  };

  const createBarChart = (data, containerRef) => {
    if (!data || data.length === 0) {
     
   
      console.log("Data cannot be found."); // Display the message
      return;
    }
    const margin = { top: 10, right: 20, bottom: 40, left: 30 };
    const width = 300 - margin.left - margin.right;
    const height = 300 - margin.top - margin.bottom;

    const svg = d3.select(containerRef)
        .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

    const x = d3.scaleLinear().range([0, width]);
    const y = d3.scaleBand().range([height, 0]).padding(0.1);

    const maxSchools = d3.max(data, d => d.schools);
    const interval = Math.ceil(maxSchools / 7);
    const xDomain = [0, maxSchools];
    x.domain(xDomain).nice(interval);

    const tickValues = Array.from({ length: Math.ceil(maxSchools / interval) + 1 }, (_, i) => i * interval);

    svg.append('g')
        .call(d3.axisLeft(y).tickSize(-width).tickValues([]));

    svg.append('g')
        .attr('transform', `translate(0,${height})`)
        .call(d3.axisBottom(x).tickValues(tickValues).tickFormat(d3.format('d')))
        .select('.domain')
        .remove();

    y.domain(data.map(d => d.value));

    svg.selectAll('.bar')
        .data(data)
        .enter().append('rect')
        .attr('class', 'bar')
        .attr('width', d => x(d.schools))
        .attr('y', d => y(d.value))
        .attr('height', 10)
        .attr('fill', '#5DADE2');

    svg.selectAll('.district-label')
        .data(data)
        .enter().append('text')
        .attr('class', 'district-label')
        .attr('x', d => x(d.schools) + 5)
        .attr('y', d => y(d.value) + 5)
        .text(d => d.value)
        .style('font-size', '9px')
        .style('text-anchor', 'start')
        .style('dominant-baseline', 'middle');

    svg.append('text')
        .attr('class', 'x-axis-label')
        .attr('transform', `translate(${width / 2},${height + margin.top + 20})`)
        .style('text-anchor', 'middle')
        .text(isEnglish ? 'Educational Institutes' : 'शैक्षिक संस्थानहरू')
        .style('font-size', '10px');

        svg.append('g')
    .attr('class', 'y-axis')
    .call(d3.axisLeft(y).tickSize(-width).tickValues([]));

    svg.append('text')
    .attr('class', 'y-axis-label')
    .attr('transform', 'rotate(-90)')
    .attr('y', 0 - margin.left + 10) // Adjust the margin by changing the value (e.g., adding 10)
    .attr('x', 0 - height / 2)
    .attr('dy', '1em')
    .style('text-anchor', 'middle')
    .text(data[0].label)
    .style('font-size', '12px');
  
   

  };

  
  return (
    <div className='static'>

      <div className='static-piechart'>
        <div className='piechart-combo'>
          <h5>{isEnglish ? 'Student Status' : 'विद्यार्थी स्थिति'}</h5>
          <div className='chart-container' ref={studentChartRef}></div>
          <div className='piechart-legend'>
            <div style={{ backgroundColor: '#1f77b4', height:"10px", width:"10px",borderRadius: '50%'}}></div>
            <p>{isEnglish ? 'Male' : 'पुरुष'}</p> 
            <div style={{ backgroundColor: '#ff7f0e', height:"10px", width:"10px",borderRadius: '50%'}}></div>
            <p>{isEnglish ? 'Female' : 'महिला'}</p> 
          </div>
        </div>
    
        <div className='piechart-combo'>
          <h5>{isEnglish ? 'Teacher Status' : 'कर्मचारी स्थिति'}</h5>
          <div className='chart-container' ref={staffChartRef}></div>
          <div className='piechart-legend'>
            <div style={{ backgroundColor: '#1f77b4', height:"10px", width:"10px", borderRadius: '50%'}}></div>
            <p>{isEnglish ? 'Male' : 'पुरुष'}</p> 
            <div style={{ backgroundColor: '#ff7f0e', height:"10px", width:"10px", borderRadius: '50%'}}></div>
            <p>{isEnglish ? 'Female' : 'महिला'}</p> 
          </div>
        </div>

        <div className='piechart-combo'>
          <h5>{isEnglish ? 'School Type' : 'शैक्षिक संस्थानहरूको प्रकार'}</h5>
          <div className='chart-container' ref={eduTypeChartRef}></div>
          <div className='piechart-legend'>
            <div style={{ backgroundColor: '#1f77b4', height:"10px", width:"10px",borderRadius: '50%'}}></div>
            <p>{isEnglish ? 'Government' : 'सरकारी'}</p> 
            <div style={{ backgroundColor: '#ff7f0e', height:"10px", width:"10px",borderRadius: '50%'}}></div>
            <p>{isEnglish ? 'Private' : 'निजी'}</p> 
          </div>
        </div>
      </div>

      <div className='bar-chart-container' ref={schoolChartRef}></div>
    </div>
  );
}

export default Stati;
